import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Services
import { userService } from '../../services/users';

// Interfaces
import type { Track } from '../../interfaces/track';
import type { Episode } from '../../interfaces/episode';

export interface QueueState {
  queue: (Track | Episode)[];
}

const initialState: QueueState = {
  queue: [],
};

export const fetchQueue = createAsyncThunk('queue/fetchQueue', async (_, thunkAPI) => {
  // Queue state is pushed by playerService via 'queue/fetchQueue/fulfilled'.
  // Returning the existing queue here ensures we don't accidentally wipe it 
  // if some old component still explicitly dispatches fetchQueue().
  const state: any = thunkAPI.getState();
  return state.queue.queue as any[];
});

const queueSlice = createSlice({
  name: 'queue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchQueue.fulfilled, (state, action) => {
      state.queue = action.payload;
    });
  },
});

export const queueActions = {
  fetchQueue,
  ...queueSlice.actions,
};

export default queueSlice.reducer;
